import React, {Fragment, useState, useEffect} from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import Script from 'react-load-script'
import axios from 'axios';
import Swal from 'sweetalert2'
import { AiFillLock } from "react-icons/ai";
import { GoInfo } from "react-icons/go";
import { Cabecera } from '../components/Cabecera';
import { Footer } from '../components/Footer';
import { ModalContacto } from '../components/ModalContacto';
import {Listadostandviruales} from '../components/Listadostandviruales'
import {Listadopreguntas} from '../components/Listadopreguntas'

export const Standvirtualpublico = (props) => {

    let { id,idEvento,idUsuario } = useParams();
    let tipoevento = 2
    const history = useHistory();
    
    const [modalContacto, setmodalContacto] = useState(false)
    const [destinatario, setdestinatario] = useState(false)
    const modalcontactochange = (val,texto = false) => {
        if(texto !== false){
            var string = texto.replaceAll('"',"'")
            console.log('string',string)
            var regex = /mailto:(.*)'/g; // The actual regex
            var matches = regex.exec(string);
            if(matches.length > 0){
                console.log('email::',matches[1]);
                setdestinatario(matches[1])
               
            }
            
            
        }
        console.log('mostarr modal::',val)
        setmodalContacto(val)
    }

    function groupBy(list, keyGetter) {
        console.log('go to group',list)
        const map = new Map();
        list.forEach((item) => {
             const key = keyGetter(item);
             if(key == 5){
              const collection = map.get(key);
              if (!collection) {
                  map.set(key, [item]);
              } else {
                  collection.push(item);
              }
             }
        });
        return map;
      }

    const playAudio = async (idAudio) => {
        if(props.isAuth){
            let BajoDemanda = false
            if(tipoevento == 1){BajoDemanda = true} 
            props.logEvento(id,BajoDemanda,'play','true')
        }
        //await logAudio(idAudio, 'Play')
    }
    const clickPause = async (idAudio) => {
        if(props.isAuth){
            let BajoDemanda = false
            if(tipoevento == 1){BajoDemanda = true} 
            props.logEvento(id,BajoDemanda,'pause','true')
        }
        //await logAudio(idAudio,'Pause')
    }   

    const logAudioEnd = async (idAudio) => {
        if(props.isAuth){
            let BajoDemanda = false
            if(tipoevento == 1){BajoDemanda = true} 
            props.logEvento(id,BajoDemanda,'endvideo','true')
        }
        //await logAudio(idAudio,'End')
    }

    

    

    
    const [dataEventos, setDataEventos] = useState(false)

    
    const fetchDataEvento = async () => {

        let urlApi = `${process.env.REACT_APP_URL_API}formatos/obtenerformatopublico`
        
        let dataFormEventos = {  
            "formato": "evento_hijo",
            "idUsuario": idUsuario,
            "idEvento": idEvento
        }
        let axiosConfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },  
        };
            
        axios.post(urlApi, dataFormEventos, axiosConfig)
        .then((res) => {

            
            tipoevento =  res.data.data[0].eventos[0].idTipoEvento

            let urlApi = `${process.env.REACT_APP_URL_API}formatos/obtenerformatopublico`
        
            let dataFormEventos = {  
                "formato": "cliente",
                "idCliente": id
            }
            let axiosConfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    
                },  
            };

            axios.post(urlApi, dataFormEventos, axiosConfig)
            .then((res) => {
                
                let BajoDemanda = false
                if( tipoevento ==  1 || tipoevento == 4){
                    BajoDemanda = true
                }else{
                    BajoDemanda = false
                } //res.data.data[0].eventos[0].idTipoEvento
                    
                   props.logEvento(idEvento,true,'visualiza-standvirtual-bajo-demanda',id)
                    

                setDataEventos(res.data.data)
                const grouped = groupBy(res.data.data, item => item.idZona);
                
            })
            .catch((err) => {
                console.log('ERROR',err)
            //  props.isAuth && props.removeAuth()
                
            }) 



        })
        .catch((err) => {
            console.log('ERROR',err)
          //  props.isAuth && props.removeAuth()
            
        }) 



        
    }

    useEffect(() => {
        fetchDataEvento();
    },[])

    //{props.eventosInscritos.find(o => o.idEvento === props.evento.idEvento) ? 

    if(!dataEventos) { return(<div></div>) }    
    return(
        <Fragment>
            
            <Cabecera imagen={true} urlimagen={dataEventos[0].imagen} texto={dataEventos[0].texto} top={false} removeAuth={props.removeAuth} datosCabecera={dataEventos} clase='standvirtual' />
            {modalContacto && destinatario &&
                <ModalContacto modalContacto={modalContacto} setmodalContacto={modalcontactochange} destinatario={destinatario} idCliente={id} />
            }
            <section className="py-5">
                <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className='logostand'>
                                {dataEventos[1].enlace !== null ?
                                <div className="imgstand"><a href={dataEventos[1].enlace} target="_blank"><img src={dataEventos[1].imagen} /></a></div>
                                :
                                <div className="imgstand"><img src={dataEventos[1].imagen} /></div>
                                }
                        </div>
                        <div className='bannerstand'>
                                <img src={dataEventos[2].imagen} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-8">
                        <div className='infostand'>
                              
                                <div dangerouslySetInnerHTML={{__html: dataEventos[3].texto} }/>
                        </div>
                        <div className='linksstand'>
                            {dataEventos.map(item=>
                                item.idZona == 6 && 
                                <>
                                <h1 className="titulostand">{item.titulo}</h1>
                                <a className="imglinkstand" href={item.enlace} target={item.target}><img src={item.imagen} /></a>
                                </>
                            )}
                            
                           
                        </div>
                     
                    </div>
                    <div className="col-md-4">
                        {dataEventos.map(item=>
                        item.idZona == 5 || item.idZona == 8  ? 
                        <div>
                            <div className="widget">
                                <div className='widgetstand'>
                                     <h1 className="titulostand">{item.titulo}</h1>
                                     <div className="bodystand">
                                       
                                        <div dangerouslySetInnerHTML={{__html: item.texto} }/>
                                        {
                                            item.texto.includes("contactolink") &&
                                            <div class="contactolinkview"><div class="btn btn-enviar" onClick={() => modalcontactochange(true,item.texto) }>¿Hablamos?</div></div>

                                        }
                                    </div>

                                </div>
                                    
                                
                            </div>
                            
                        </div>
                        :
                        <div></div>
                         )}
                         
                        
                    
                    </div>
                </div>
                </div> 
            </section>
            
            
            <Footer />
        </Fragment>
    )

}